import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import { AlertTriangle } from "lucide-react";

export default function UnmatchedVendorsStrip({ days = 7 }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    api
      .get("/statements/unmatched-vendors", { params: { days } })
      .then((r) => {
        if (alive) setItems(r.data?.items || []);
      })
      .catch(() => {
        if (alive) setItems([]);
      })
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [days]);

  if (loading || items.length === 0) return null;

  return (
    <div
      data-testid="unmatched-vendors-strip"
      className="mb-6 rounded-lg border border-amber-200 bg-amber-50/60 p-4"
    >
      <div className="mb-3 flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 text-amber-700" />
        <h2 className="text-sm font-semibold text-amber-900">
          Top unmatched vendors · last {days} days
        </h2>
      </div>
      <div className="flex flex-wrap gap-2">
        {items.map((it) => (
          <div
            key={it.token}
            data-testid={`unmatched-vendor-${it.token.replace(/\s+/g, "_")}`}
            className="flex items-center gap-2 rounded-md border border-amber-200 bg-white px-3 py-2 shadow-sm"
          >
            <span className="font-mono text-xs font-medium text-slate-700">{it.token}</span>
            <Badge variant="secondary" className="bg-amber-100 text-amber-900 hover:bg-amber-100">
              {it.count}
            </Badge>
            <Button
              variant="ghost"
              size="sm"
              className="h-7 px-2 text-xs text-[#0F1E3D] hover:bg-[#0F1E3D]/5"
              data-testid={`triage-${it.token.replace(/\s+/g, "_")}`}
              onClick={() =>
                navigate(`/statements?match_status=unmatched&q=${encodeURIComponent(it.token)}`)
              }
            >
              Triage
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
